import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Laura G.',
  detail: '37 años · Buenos Aires',
  text: 'Me ayudó a tener todo más organizado. Cuando aparece una molestia chiquita, ya sé dónde buscar primero en vez de quedarme dando vueltas en internet.'
}, {
  name: 'Marcela D.',
  detail: '55 años · Rosario',
  text: 'Me recordó muchas cosas que hacía mi abuela. Está explicado simple, sin palabras raras. Es de esos libros que terminás usando todas las semanas.'
}, {
  name: 'Patricia S.',
  detail: '49 años · Córdoba',
  text: 'Me gustó que sea responsable. Explica cuándo un remedio puede ayudar y cuándo conviene consultar a un profesional. Eso me dio mucha confianza.'
}, {
  name: 'Florencia B.',
  detail: '38 años · Mendoza',
  text: 'Lo tengo en el celular y lo abro varias veces por semana. Las recetas para descansar mejor y las infusiones digestivas son las que más uso.'
}, {
  name: 'Claudia F.',
  detail: '52 años · Tucumán',
  text: 'Está muy bien organizado por sistema y por síntoma. Encontrás rápido lo que buscás. Para mí eso era lo más importante.'
}, {
  name: 'Sofía E.',
  detail: '36 años · Buenos Aires',
  text: 'La compré sin demasiadas expectativas y me terminó encantando. Tiene muchísimo contenido y los bonos extra son muy útiles.'
}];
export function Testimonials() {
  return <section className="py-12 md:py-20 px-5 bg-cream-100 texture-paper" data-id="element-206">
      <div className="max-w-5xl mx-auto" data-id="element-207">
        <div className="text-center mb-8 md:mb-12 max-w-2xl mx-auto" data-id="element-208">
          <p className="text-xs uppercase tracking-[0.2em] text-olive-600 font-medium mb-4" data-id="element-209">
            Lo que dicen quienes la usan
          </p>
          <h2 className="font-serif font-medium text-3xl md:text-4xl text-ink-900 leading-tight" data-id="element-210">
            Una guía que se vuelve{' '}
            <span className="italic text-olive-600" data-id="element-211">parte del día a día</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-212">
          {testimonials.map((t, idx) => <div key={idx} className="bg-cream-50 border border-cream-300 rounded-2xl p-6 flex flex-col" data-id="element-213">
              <div className="flex gap-0.5 mb-4" data-id="element-214">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-olive-500 text-olive-500" data-id="element-215" />)}
              </div>
              <p className="font-serif text-base md:text-lg text-ink-800 leading-relaxed italic mb-5 flex-1" data-id="element-216">
                "{t.text}"
              </p>
              <div className="pt-4 border-t border-cream-300" data-id="element-217">
                <p className="font-medium text-ink-900 text-sm" data-id="element-218">{t.name}</p>
                <p className="text-xs text-ink-600" data-id="element-219">{t.detail}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}